var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('p',[_vm._v(_vm._s(_vm.$t(_vm.title)))]),(_vm.kpiData && _vm.kpiData.value )?_c('h2',[_vm._v(_vm._s(_vm.formatValue(_vm.kpiData.value)))]):_c('h2',[_vm._v(_vm._s(_vm.formatValue(0)))])])}
var staticRenderFns = []

export { render, staticRenderFns }